import { mapState, mapMutations } from "vuex";
import { conversion } from "@/tool";
import Avatar from "@/components/avatar";
import {
  api_TransferRedPacketBalance,
  api_RedPacketBalanceToCash,
  api_CashToRedPacketBalance,
  api_RedPacketSettings,
  api_GetSubProfileByUid
} from "@/api";


export default {

	filters: {
		conversion,
	},
	components: {
		"c-avatar": Avatar,
	},
	data() { return {
		qty: 0,
		move_type: 1, // 1  余额转红包 0 红包转余额
		target_id: '',
		target_profile: null, // 目标用户信息
		amount: 0,
		setting: {
			minRedPacketAmount: 1, // 红包币余额
			maxRedPacketAmount: 1,
			canTransferToRedPacketAmount: 1, // 可转入红包币余额
			isAllowSendRedPacket: false, // 是否允许发送红包
		},
		transfer_ready: false, // 是否可以发送红包
	}},

	computed: {
		...mapState(["user"]),
		inputQty: {
			get() {
				return this.qty === 0 || isNaN(this.qty) ? '' : this.qty.toString();
			},
			set(value) {
				// 输入为空时重置为 0，否则转为数字
				this.qty = value === '' ? 0 : value > 0 ? Number(value) : 0;
			}
		},
		inputAmount: {
			get() {
				return this.amount === 0 || isNaN(this.amount) ? '' : this.amount.toString();
			},
			set(value) {
				// 输入为空时重置为 0，否则转为数字
				this.amount = value === '' ? 0 : value > 0 ? Number(value) : 0;
			}
		}
	},

	watch: {
		target_id(newVal, oldVal) {
			// console.log("输入变化：", newVal);
			this.transfer_ready = newVal.trim() !== '' && this.inputAmount.trim() !== '' && this.target_profile !== null;
		},
		inputAmount(newVal, oldVal) {
			this.transfer_ready = newVal.trim() !== '' && this.target_id.trim() !== '' && this.target_profile !== null;;
			// console.log("输入变化：", this.transfer_ready);
		},
	},

	async created() {
		this.getRedPacketSettings();
	},

	async mounted() {
	},

	async beforeDestroy() {
	},


	methods: {
		onChangeMoveType() {
			this.qty = 0;
			this.move_type = this.move_type === 1 ? 0 : 1;
		},
		onSearchUser() {
			if (this.target_id.trim() === "") {
				this.$message.error("请输入赠送对象UID");
				return;
			}
			this.getTransferProfileInfo()
		},
		async getTransferProfileInfo() {
			try {
				const res = await api_GetSubProfileByUid({
					uid: this.target_id.trim(),
				});
				if (res.data.code === 0) {
					// console.log("获取用户信息成功：", res.data.data);
					this.target_profile = res.data.data;
					this.transfer_ready = this.target_id.trim() !== '' && this.inputAmount.trim() !== '' && this.target_profile !== null;
				} else {
					this.$message.error(res.data.msg);
				}
			} catch (error) {
				this.$message.error("搜索用户失败，请稍后再试");
			}
		},
		async getRedPacketSettings() {
			try {
				const res = await api_RedPacketSettings();
				if (res.data.code === 0) {
					this.setting = res.data.data;
				} else {
					this.$message.error(res.data.msg);
				}
			} catch (error) {
				this.$message.error("获取红包配置失败，请稍后再试");
			}
		},
		async onMoveBalance() {
			if (this.qty <= 0) {
				this.$message.error("请输入转换数量");
				return;
			}
			if (this.move_type === 1 && this.qty > this.user.recycles) {
				this.$message.error("商城币余额不足");
				return;
			}
			if (this.move_type === 0 && this.qty > this.user.redPacketBalance) {
				this.$message.error("红包币余额不足");
				return;
			}

			try {
				if (this.move_type === 1) {
					const res = await api_CashToRedPacketBalance({
						val: this.qty,
					});
					if (res.data.code === 0) {
						this.$store.commit("setInfo");
						this.$message.success("转换成功");
						this.qty = 0;
					} else {
						this.$message.error(res.data.msg);
					}
				} else {
					const res = await api_RedPacketBalanceToCash({
						val: this.qty,
					});
					if (res.data.code === 0) {
						this.$store.commit("setInfo");
						this.$message.success("转换成功");
						this.qty = 0;
					} else {
						this.$message.error(res.data.msg);
					}
				}
			}
			catch (error) {
				this.$message.error("转换失败，请稍后再试");
			}
		},
		async onTransferRedPacket() {
			if (this.transfer_ready) {
				if (this.target_id.trim() === "") {
					this.$message.error("请输入赠送对象UID");
					return;
				}
				if (this.amount <= 0) {
					this.$message.error("请输入红包金额");
					return;
				}
				if (this.amount > this.user.redPacketBalance) {
					this.$message.error("红包币余额不足");
					return;
				}
				try{
					const res = await api_TransferRedPacketBalance({
						targetId: this.target_id,
						amount: this.amount,
					});
					if (res.data.code === 0) {
						this.$store.commit("setInfo");
						this.$message.success("红包赠送成功");
						this.target_id = '';
						this.amount = 0;
					} else {
						this.$message.error(res.data.msg);
					}
				} catch (error) {
					this.$message.error("红包赠送失败，请稍后再试");
				}
			}
		},
	},

};
